export type IconProps = React.SVGProps<SVGSVGElement>;

export function CheckIcon(props: IconProps) {
   return (
      <svg width="11" height="8" viewBox="0 0 11 8" fill="currentColor" {...props}>
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2355 0.812752L10.2452 0.824547C10.4585 1.08224 10.4617 1.48728 10.1855 1.74621L4.85633 7.09869C4.66442 7.29617 4.41535 7.4001 4.14693 7.4001C3.89823 7.4001 3.63296 7.29979 3.43735 7.09851L0.788615 4.43129C0.536589 4.1703 0.536617 3.758 0.788643 3.49701C1.04747 3.22897 1.4675 3.22816 1.72731 3.49457L4.16182 5.94608L9.28643 0.799032C9.54626 0.532887 9.96609 0.533789 10.2248 0.801737L10.2355 0.812752Z"
            fill=""
         />
      </svg>
   );
}
